// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./assets/theme/index.css";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import Vue from "vue";
import Vuelidate from "vuelidate";
import axios from "axios";
import router from "./router";
import { API_URL } from "@/config";
import store from "@/utils/store";
import * as auth from "@/utils/auth";
import App from "./App";

Vue.use(ElementUI, { locale });

axios.defaults.baseURL = API_URL;
axios.defaults.withCredentials = true;
axios.defaults.headers = {
	"Access-Control-Allow-Origin": "*"
};

axios.interceptors.request.use(request => {
	store.isLoading = true;
	return request;
});

axios.interceptors.response.use(
	function(response) {
		store.isLoading = false;
		return response;
	},
	function(error) {
		store.isLoading = false;
		if (error.request.status === 401 || error.request.status === 400) {
			auth.endSession();
		}
		return Promise.reject(error);
	}
);

Vue.config.productionTip = false;

Vue.use(Vuelidate);

/* eslint-disable no-new */
const app = new Vue({
	el: "#app",
	data: {
		app: store
	},
	router,
	template: "<App/>",
	components: { App },
	methods: {
		updateStatus: function() {
			if (typeof window.navigator.onLine === "undefined") {
				this.app.isOnline = true;
			} else {
				this.app.isOnline = window.navigator.onLine;
			}
		}
	}
});

window.addEventListener("online", app.updateStatus);
window.addEventListener("offline", app.updateStatus);



// WEBPACK FOOTER //
// ./src/main.js